import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        fill="none"
        viewBox="0 0 24 24"
        ref={ref}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13.658 4.004a.7.7 0 0 1 .988 0l6.148 6.122a.7.7 0 0 1 0 .992L13.08 18.8h7.22a.7.7 0 1 1 0 1.4H8.311a.7.7 0 0 1-.494-.204l-4.61-4.592a.7.7 0 0 1 0-.992l10.45-10.408ZM11.096 18.8l1.449-1.443-5.156-5.134-2.697 2.685L8.6 18.8h2.496Zm-2.715-7.565 5.156 5.134 5.771-5.747-5.156-5.134-5.771 5.747Z"
            clipRule="evenodd"
        />
    </svg>
);
const ForwardRef = forwardRef(SvgComponent);
export default ForwardRef;
